var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "admin-page-content" }, [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "col-md-12 error-detail-main forms-container" },
            [
              _c("div", { staticClass: "error-template" }, [
                _c("h1", [_vm._v("Oops!")]),
                _vm._v(" "),
                _c("h2", [_vm._v("403")]),
                _vm._v(" "),
                _c("div", { staticClass: "error-details" }, [
                  _vm._v(
                    "Sorry!, You don't have permission to access this page."
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b799778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b799778","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccessDenied/NoAccessPermission.vue
// module id = null
// module chunks = 